// Иконка лампочки — категория «Идея».
import React from "react";

export function LightBulbIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.5 14a5 5 0 1 1 5 0c-.5.4-.7 1-.7 1.6V17h-3.6v-1.4c0-.6-.3-1.2-.7-1.6Z" />
      <path d="M10 19h4M10.5 21h3" />
    </svg>
  );
}

export default LightBulbIcon;
